import queryString from "query-string";
import { INVITES } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";

import { operationAction } from "../operations/operationActions.js";
import {
  getEntity,
  updateEntity,
  deleteEntity
} from "../../actions/actionUtils.js";

export function getInvite(id, options) {
  return getEntity(INVITES, id, options);
}

export const getInvites = (searchParams, options) => {
  return {
    type: INVITES.GET,
    payload: {
      endpoint: ENDPOINTS.INVITES,
      ...queryString.parse(searchParams)
    },
    options
  };
};

export function updateInvite(id, data) {
  return updateEntity(INVITES, id, data);
}

export function deleteInvite(id) {
  return deleteEntity(INVITES, id);
}

export const inviteOperationAction = (invite, operationName, data, options) => {
  return operationAction(INVITES, invite, operationName, data, options);
};
